import { type ITypedReduxAction } from '../../types/redux/actionType';
import { type IComparisonAlbum } from '../../repositories/property-comparison/entities/v1_get_comparison_albums/ComparisonAlbum';

export enum EComparisonAlbumsActionTypes {
  Loading = 'comparisonAlbums/LOADING',
  Succeed = 'comparisonAlbums/SUCCEED',
  Failed = 'comparisonAlbums/FAILED',
}

export type TComparisonAlbumsLoading = ITypedReduxAction<EComparisonAlbumsActionTypes.Loading>;
export type TComparisonAlbumsSucceed = ITypedReduxAction<EComparisonAlbumsActionTypes.Succeed, IComparisonAlbum[]>;
export type TComparisonAlbumsFailed = ITypedReduxAction<EComparisonAlbumsActionTypes.Failed>;

export type TComparisonAlbumsActions = TComparisonAlbumsLoading | TComparisonAlbumsSucceed | TComparisonAlbumsFailed;
